import Vue from '@/main'
import store from "@/store/store.js"
import {getCurrentTenant} from "@/utils";
import internalChatMessages from '@/http/requests/internalChatMessages';

export default {
  fetch({commit}, {
    userId,
    userSendingId,
    searchFilter = '',
    paginationPage = 1,
    paginationLimit = 15,
    concatResults = false,
  }) {
    return new Promise((resolve, reject) => {
      store.dispatch('setShowLoadingOverlay', false)
      internalChatMessages.fetchPaginated(
        userId,
        userSendingId,
        searchFilter,
        paginationPage,
        paginationLimit,
      ).then((response) => {
        store.dispatch('setShowLoadingOverlay', true)
        commit('SET_INTERNAL_CHAT_MESSAGES', {
          userId: userId,
          concatResults: concatResults,
          items: response.data.data['paginatedInternalChatMessage']['items'],
        })
        resolve(response)
      }).catch((error) => {
        store.dispatch('setShowLoadingOverlay', true)
        reject(error);
      })
    })
  },
  infos({commit}, internalChatMessageId) {
    return new Promise((resolve, reject) => {
      internalChatMessages.infos(internalChatMessageId)
        .then((response) => {
          commit('SET_INTERNAL_CHAT_MESSAGE_INFOS', response.data.data.internalChatMessageInfos);
          resolve(response);
        }).catch((exception) => {
          reject(exception);
        });
    })
  },
  resetUnseenInternalChatMessages({commit}, {userId, userSendingId}) {
    return new Promise((resolve, reject) => {
      store.dispatch('setShowLoadingOverlay', false)
      internalChatMessages.resetUnseenInternalChatMessages(
        userId,
        userSendingId
      ).then((response) => {
        store.dispatch('user/setUnseenMessages', {userId: userSendingId})
        store.dispatch('setShowLoadingOverlay', true)
        resolve(response)
      }).catch((error) => {
        store.dispatch('setShowLoadingOverlay', true)
        reject(error)
      })
    })
  },
  sendInternalChatMessage({commit}, data) {
    return new Promise((resolve, reject) => {
      internalChatMessages.sendChatMessage(data)
        .then((response) => { resolve(response); })
        .catch((error) => { reject(error); });
    });
  },
  sendImageInternalChatMessage({commit}, data) {
    return new Promise((resolve, reject) => {
      internalChatMessages.sendChatImage(data)
        .then((response) => { resolve(response); })
        .catch((error) => { reject(error); });
    });
  },
  resetInternalChatMessage({commit}, data) {
    return new Promise((resolve) => {
      commit('RESET_INTERNAL_CHAT_MESSAGES')
      resolve()
    });
  },
  setInternalChatMessage({commit}, data) {
    return new Promise((resolve) => {
      commit('SET_INTERNAL_CHAT_MESSAGES', {
        concatResults: true,
        items: [data],
        userId: data.user_id,
      })
      resolve()
    });
  },
  setReplyMessage({commit}, chatMessage) {
    commit('SET_REPLY_MESSAGE', chatMessage)
  },
  socketListeners({commit, state}) {
    if (!store.getters["internalChatMessages/isSocketAlreadyListened"]) {
      Vue.$events.on('InternalChatMessageCreated', ({tenantName, internalChatMessages}) => {
        const { AppActiveUser } = store.state;

        if (!AppActiveUser || tenantName !== getCurrentTenant()) {
          return;
        }

        if (internalChatMessages.user_sending_id === AppActiveUser.id && internalChatMessages.user_id === store.getters["internalChatMessages/selectedInternalUserId"]){
          store.dispatch('internalChatMessages/fetch', {
            userId: internalChatMessages.user_id,
            userSendingId: internalChatMessages.user_sending_id,
          })
        } else if (internalChatMessages.user_id === AppActiveUser.id && internalChatMessages.user_sending_id === store.getters["internalChatMessages/selectedInternalUserId"]){
          store.dispatch('internalChatMessages/fetch', {
            userId: internalChatMessages.user_sending_id,
            userSendingId: internalChatMessages.user_id,
          })
        } else if (AppActiveUser.id === internalChatMessages.user_id && AppActiveUser.id !== internalChatMessages.user_sending_id) {
           commit('INTERNAL_CHAT_NOTIFICATION')
           store.dispatch('user/setUnseenMessages', {userId: internalChatMessages.user_sending_id, increments: true})

          if (Notification) {
            if (Notification.permission !== 'denied') {
              Notification.requestPermission();
            }
          } else { console.error('O browser não suporta notificações desktop'); }

          if (Notification.permission !== 'granted') {
            Notification.requestPermission();
          } else {
            const date = new Date;

            const currentHourAndMinutes = `${
              date.getHours() < 10 ? '' + date.getHours() : date.getHours()
            }:${
              date.getMinutes() < 10 ? '' + date.getMinutes() : date.getMinutes()
            }`;

            new Notification((internalChatMessages['user_name'] ? `${internalChatMessages['user_name']} - Chat Interno` : 'Chat Interno'), {
              body: `${internalChatMessages.message} - ${currentHourAndMinutes}`,
            });
          }
        }
      })

      Vue.$events.on('InternalChatMessagesAckChanged', ({tenantName, internalChatMessages}) => {
        const { AppActiveUser } = store.state;

        if (!AppActiveUser || tenantName !== getCurrentTenant()) {
          return;
        }

        if (
          internalChatMessages.user_id === store.getters["internalChatMessages/selectedInternalUserId"] ||
          internalChatMessages.user_sending_id === store.getters["internalChatMessages/selectedInternalUserId"]
        ){
          commit('SET_ACK_MESSAGE', internalChatMessages)
        }
      });

      commit('SOCKET_WAS_LISTENED')
    }
  }
}